import axios from "@/services/axios";
import UrlKeeper from '@/services/UrlKeeper.js'

class schedulePaymentsSettingsManagment {

  list(page, rowPerPage, filters) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      axios.post(apiUrl + '/payments/schedulePaymentsSettings/list', {
        page: page,
        rowPerPage: rowPerPage,
        filters: filters
      }).then((response) => {
        if (response.success) {
          resolve(response.results)
        } else {
          reject(response.results)
        }
      }).catch((err) => {

        reject(err)
      })
    })
  }

  create(tax) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      axios.post(apiUrl + '/payments/schedulePaymentsSettings/create', tax).then((response) => {
        if (response.success) {
          resolve(response.results)
        } else {
          reject(response.results)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }


  update(tax) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      axios.post(apiUrl + '/payments/schedulePaymentsSettings/update', tax).then((response) => {
        if (response.success) {
          resolve(response.results)
        } else {
          reject(response.results)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }

  delete(tax) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      if (!tax.id) {
        reject('id undefined')
      }
      axios.post(apiUrl + '/payments/schedulePaymentsSettings/delete', {
        id: tax.id
      }).then((response) => {
        if(!response.success) {
          reject(response.results)
        } else {
          resolve(response.results)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }

  get(taxId) {
    const apiUrl = UrlKeeper.getUrl()

    return new Promise((resolve, reject) => {
      axios.get(apiUrl + '/payments/schedulePaymentsSettings/get', { id: taxId }).then((response) => {
        if (response.success) {
          resolve(response.results)
        } else {
          reject(response.results)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  }
  
  fields() {
    return Promise.resolve([
      { text: 'Descrizione', value: 'description' },
      { text: 'Importo da', value: 'amountFrom' },
      { text: 'Importo a', value: 'amountTo' },
      { text: 'Numero rate', value: 'numberOf' },
      { text: 'Percentuale Acconto', value: 'percetageAdvance' },
      { text: 'Percentuale Rata', value: 'percetageInstallment' },
      { text: 'Data Creazione', value: 'createdAt',type: "datetime"  },
    ])
  }
}

export default new schedulePaymentsSettingsManagment();
